import { Component } from '@angular/core';

@Component({
  selector: 'app-calculation-web-center-header',
  templateUrl: './calculation-web-center-header.component.html',
  styleUrls: ['./calculation-web-center-header.component.scss']
})
export class CalculationWebCenterHeaderComponent {

}
